import classNames from 'classnames';
import { type FC, useMemo } from 'react';

import Icon from 'components/Icon/Icon';
import Link from 'components/Link';

import styles from './Menu.module.scss';
import type { MenuItemProps } from './types.ts';

const MenuItem: FC<MenuItemProps> = ({ item, renderIcon, onClick }) => {
  const icon = useMemo(() => {
    if (renderIcon) {
      return renderIcon(item);
    }
    if (!item.icon) {
      return null;
    }
    return <Icon name={item.icon} />;
  }, [item, renderIcon]);

  const itemContent = useMemo(() => {
    return (
      <>
        {icon && (
          <span className={classNames(styles.icon, 'cc-navigation-menu-icon')}>
            {icon}
          </span>
        )}
        <div className={styles.label}>{item.label}</div>
      </>
    );
  }, [icon, item.label]);

  if (item.link) {
    return (
      <Link
        to={item.link}
        activeStrategy="nested"
        className={(active) =>
          classNames(styles.item, {
            [styles.active]: active,
          })
        }
      >
        {itemContent}
      </Link>
    );
  }

  return (
    <button
      type="button"
      className={styles.item}
      onClick={() => onClick?.(item)}
    >
      {itemContent}
    </button>
  );
};

export default MenuItem;
